import React, { useState } from 'react';
import { ReactComponent as Pencils } from '../../assets/icons/pencil-orange.svg';
import FormCreate from './FormCreate';

const TabFee = () => {
  const [showCreateForm, setCreateForm] = useState(false);

  function handleShowPopup() {
    setCreateForm(!showCreateForm);
  }

  let dataTable = [
    {
      city: 'Malang',
      fee: '10.000',
      feeKm: '2.000',
      discount: '2.000',
      minimumOrder: '150.000',
      startDate: '06/08/2020',
      endDate: '06/09/2020',
    },
    {
      city: 'Surabaya',
      fee: '10.000',
      feeKm: '2.000',
      discount: '2.000',
      minimumOrder: '150.000',
      startDate: '06/08/2020',
      endDate: '06/09/2020',
    },
    {
      city: 'Jogja',
      fee: '10.000',
      feeKm: '2.000',
      discount: '2.000',
      minimumOrder: '150.000',
      startDate: '06/08/2020',
      endDate: '06/09/2020',
    },
    {
      city: 'Bandung',
      fee: '10.000',
      feeKm: '2.000',
      discount: '2.000',
      minimumOrder: '150.000',
      startDate: '06/08/2020',
      endDate: '06/09/2020',
    },
    {
      city: 'Jakarta',
      fee: '10.000',
      feeKm: '2.000',
      discount: '2.000',
      minimumOrder: '150.000',
      startDate: '06/08/2020',
      endDate: '06/09/2020',
    },
  ];

  return (
    <>
      <div className="flex flex-col w-full">
        <div className="px-4">
          <h1 className="text-bold text-2xl mb-4">Ongkos Kirim</h1>
        </div>
        <button
          onClick={() => handleShowPopup(!showCreateForm)}
          className="bg-orange-500 text-white font-bold py-2 px-4 rounded ml-auto mb-4"
        >
          + Tambah
        </button>
        <table className="table-auto w-full">
          <thead>
            <tr>
              <th className="text-sm px-4 py-2 border-t border-b  border-gray-300 text-center leading-4 text-gray-600">
                Kota
              </th>
              <th className="text-sm px-4 py-2 border-t border-b  border-gray-300 text-center leading-4 text-gray-600">
                Tarif
              </th>
              <th className="text-sm px-4 py-2 border-t border-b  border-gray-300 text-center leading-4 text-gray-600">
                Tarif/Km
              </th>
              <th className="text-sm px-4 py-2 border-t border-b  border-gray-300 text-center leading-4 text-gray-600">
                Diskon
              </th>
              <th className="text-sm px-4 py-2 border-t border-b  border-gray-300 text-center leading-4 text-gray-600">
                Minimum Order
              </th>
              <th className="text-sm px-4 py-2 border-t border-b  border-gray-300 text-center leading-4 text-gray-600">
                Mulai
              </th>
              <th className="text-sm px-4 py-2 border-t border-b  border-gray-300 text-center leading-4 text-gray-600">
                Akhir
              </th>
              <th className="text-sm px-4 py-2 border-t border-b  border-gray-300 text-center leading-4 text-gray-600"></th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {dataTable.map((item, index) => (
              <tr>
                <td className="px-3 py-2 whitespace-no-wrap border-b border-gray-300">
                  <div className="text-center text-base leading-5 text-gray-600 ">
                    {item.city}
                  </div>
                </td>
                <td className="px-3 text-sm py-2 whitespace-no-wrap border-b border-gray-300">
                  <div className="text-center text-base leading-5 text-gray-600 ">
                    {item.fee}
                  </div>
                </td>
                <td className="px-3 text-sm py-2 whitespace-no-wrap border-b border-gray-300">
                  {item.feeKm}
                </td>
                <td className="px-3 text-sm py-2 whitespace-no-wrap border-b border-gray-300">
                  {item.discount}
                </td>
                <td className="px-3 text-sm py-2 whitespace-no-wrap border-b border-gray-300">
                  {item.minimumOrder}
                </td>
                <td className="px-3 text-sm py-2 whitespace-no-wrap border-b border-gray-300">
                  {item.startDate}
                </td>
                <td className="px-3 text-sm py-2 whitespace-no-wrap border-b border-gray-300">
                  {item.endDate}
                </td>
                <td className="px-3 text-sm py-2 whitespace-no-wrap border-b border-gray-300">
                  <button onClick={() => handleShowPopup(!showCreateForm)}>
                    <Pencils className="m-8" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showCreateForm ? <FormCreate handdleClick={handleShowPopup} /> : null}
    </>
  );
};

export default TabFee;
